import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { merchantSwitchSuccessAsync } from "../actions/MerchantSwitch.action";
import { IMerchantSwitchState } from "models/Slices/merchantSlice.model";
import { IAuthNativeSuccessResponse } from "models/Login/choiceMerchant.model";

const initialState: IMerchantSwitchState = {
  merchantAuthSuccess: null,
  loading: false,
  error: "",
  success: false,
  isVisibleProfileMenu: false,
};

export const merchantSwitchSlice = createSlice({
  name: "merchantSwitch",
  initialState,
  reducers: {
    resetMerchantSwitch: (state) => {
      state.success = false;
      state.loading = false;
      state.merchantAuthSuccess = null;
      state.isVisibleProfileMenu = false;
    },
    resetMerchantSwitchError: (state) => {
      state.error = "";
    },
    setMerchantAuthSuccess: (
      state,
      action: PayloadAction<IAuthNativeSuccessResponse>
    ) => {
      state.merchantAuthSuccess = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(merchantSwitchSuccessAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        merchantSwitchSuccessAsync.fulfilled,
        (state, action: PayloadAction<IAuthNativeSuccessResponse>) => {
          state.loading = false;
          state.merchantAuthSuccess = action.payload;
          state.success =
            state.merchantAuthSuccess?.ErrorCode == null ? true : false;
          state.isVisibleProfileMenu = true;
        }
      )
      .addCase(merchantSwitchSuccessAsync.rejected, (state, action: any) => {
        state.loading = false;
        state.error = action.error?.message;
        state.success = false;
      });
  },
});

export const {
  resetMerchantSwitch,
  setMerchantAuthSuccess,
  resetMerchantSwitchError,
} = merchantSwitchSlice.actions;

export const selectSwitchAuthSuccess = (state: RootState) =>
  state.merchantSwitch.success;

export const selectAuthSuccessAccessToken = (state: RootState) =>
  state.merchantSwitch.merchantAuthSuccess?.access_token;

export default merchantSwitchSlice.reducer;
